<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.source}">
      <select :value="source" name="source" class="form-control" @change="handleChange">
        <option value="" selected="selected">
          Select Survey
        </option>
        <option v-for="(field, value) in config.surveySources" :value="field.id">
          {{ field.name }}
        </option>
      </select>
    </div>
    <div v-if="source">
      <div :class="{'has-error':errors.fieldset}">
        <select :value="selectedFieldset" name="fieldset" class="form-control" @change="handleChange">
          <option value="" selected="selected">
            Select Field
          </option>
          <option v-for="(field) in config.surveySources[source].fields" :value="field.export_tag">
            {{ field.label }} ({{ field.export_tag }})
          </option>
        </select>
      </div>
      <div v-if="fieldset">
        <div v-if="showNumericOperators">
          <span :class="{'has-error':errors.operator}">
            <select :value="operator" name="operator" class="form-control" @change="handleChange">
              <option value="" selected="selected">Select Operator</option>
              <option value="lt">&lt;</option>
              <option value="lte">≤</option>
              <option value="gt">&gt;</option>
              <option value="gte">≥</option>
              <option value="eq">=</option>
              <option value="neq">≠</option>
              <option value="textEmpty">Is Empty</option>
              <option value="textNotEmpty">Is Not Empty</option>
            </select>
          </span>
          <template v-if="operatorTakesArgs">
            <select :value="amountortarget" name="amountortarget" class="form-control" @change="handleChange">
              <option value="amount" selected="selected">
                Amount:
              </option>
              <option v-if="config.targets && Object.keys(config.targets).length > 0" value="target">
                Target
              </option>
            </select>
            <span :class="{'has-error':errors.amount}">
              <input
                v-if="amountortarget === 'amount'"
                :value="amount"
                name="amount"
                class="form-control input-numeric"
                @input="handleChange"
              >
            </span>
          </template>
        </div>
        <div v-else :class="{'has-error':errors.compliantChoices}">
          is one of
          <div v-for="(label, value) in availableChoices">
            <label>
              <input
                v-model="selectedCompliantChoices"
                :value="value"
                type="checkbox"
                name="compliantChoices"
              >
              {{ label }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';
  import _get from 'lodash.get';
  import { unaryOperators } from "@/EventLogic/operators";

  export default {
    extends: BaseComponent,

    props: {
      // Fundamentally numbers, but often stored as a string
      source: [Number, String],
      fieldset: [Number, String],
      amountortarget: {
        type: String,
        default: 'amount'
      },
      amount: [Number, String],
      operator: String,
      compliantChoices: {
        type: Array,
        default: function () {
          return [];
        }
      },
      id: String,
    },
    data: function () {
      return {
        selectedCompliantChoices: this.compliantChoices,
        selectedFieldset: this.fieldset,
      }
    },
    computed: {
      showNumericOperators() {
        return _get(this.config, ['surveySources', this.source, 'fields', this.selectedFieldset, 'numeric'], false);
      },
      operatorTakesArgs() {
        return unaryOperators.includes(this.operator) === false;
      },
      availableChoices() {
        return _get(this.config, ['surveySources', this.source, 'fields', this.fieldset, 'choices'], []);
      }
    },
    watch: {
      'selectedCompliantChoices': function () {
        this.$emit('update:compliantChoices', this.selectedCompliantChoices);
      },
      'compliantChoices': function (value) {
        this.selectedCompliantChoices = value;
      },
      'source': function () {
        this.selectedFieldset = '';
      },
      'selectedFieldset': function () {
        this.$emit('update:fieldset', this.selectedFieldset);
        this.selectedCompliantChoices = [];
      },
      'fieldset': function (value) {
        this.selectedFieldset = value;
      },
      'operatorTakesArgs': function (val) {
        if (!val) {
          // only text type allows unary operators
          this.$emit('update:amountortarget', 'text');
        }
      }
    },
    methods: {
      validate: function () {
        this.errors = {};

        if (!this.config.surveySources[this.source]) {
          this.errors.source = 'Please select a survey.';
        } else if (!this.config.surveySources[this.source].fields[this.fieldset]) {
          this.errors.fieldset = 'Please select a survey field.';
        } else if (this.showNumericOperators) {
          if (!this.operator) {
            this.errors.operator = "Please select a comparison operator.";
          }
          if (this.amountortarget === "amount" && !this.isNumber(this.amount)) {
            this.errors.amount = "Please enter an amount for the comparison.";
          }
        } else if (this.compliantChoices.length < 1) {
          this.errors.compliantChoices = "Please select at least one valid choice.";
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
